import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { isBrowser } from "react-device-detect"
import { push } from 'connected-react-router'
import {
    addImageClickEventListener,
    removeImageClickEventListener
} from '../../utils/common'
import InnerHtml from '../utils/InnerHtmlWrapper'
import BoxContainer from '../BoxContainer'
import '../../styles/frontpage.scss'
import Lightbox from 'react-image-lightbox'


class ReadFrontpage extends React.Component {

    state = {
        lightboxOpen: false,
        imageIndex: 0
    }

    componentDidUpdate = prevProps => {
        const newImageList = _.get(this.props, 'lightbox', [])
        const prevImageList = _.get(prevProps, 'lightbox', [])

        if (! _.isEqual(newImageList, prevImageList)) {
            removeImageClickEventListener('.frontpage', prevImageList, this.imageClick)
            addImageClickEventListener('.frontpage', newImageList, this.imageClick)
        }
    }

    imageClick = event => {
        const imageList = _.get(this.props, 'lightbox', [])
        const index = imageList.findIndex(p => p === event.target.src)
        this.setState({
            lightboxOpen: true,
            imageIndex: index !== -1 ? index : 0
        })
    }

    componentDidMount = () => {
        const lightboxList = _.get(this.props, 'lightbox', [])

        addImageClickEventListener('.frontpage', lightboxList, this.imageClick)
    }

    componentWillUnmount = () => {
        const lightboxList = _.get(this.props, 'lightbox', [])
        removeImageClickEventListener('.frontpage', lightboxList, this.imageClick)
    }

    mapBoxContainerData = item => {

        const maybeThumbnail = isBrowser
            ? _.get(item, 'thumbnail.web', null)
            : _.get(item, 'thumbnail.mobile', null)

        return {...item, image: maybeThumbnail}
    }

    renderRecommendations = (recommendation, idx) => {

        const items = _.get(recommendation, 'items', [])
        const href = _.get(recommendation, 'href', null)

        return items.length ? (
            <div key={idx}>
                <h2 className={`${href !== null ? "pointer category-link with-icon" : ""}`} onClick={() => this.props.dispatch(push(href))}>
                    {recommendation.name}
                </h2>
                <div key={idx} className={"recommendation-boxes"}>
                    <BoxContainer items={items.map(this.mapBoxContainerData)}  />
                </div>
            </div>
        ) : null
    }


    render = () => {

        const { prequel, midquel, sequel, news, recommendations } = this.props.data
        const images = _.get(this.props, 'lightbox', [])
        const { imageIndex } = this.state

        return (
            <>
                <div className={"read frontpage"}>
                    <div className={"prequel"}>
                        <InnerHtml html={prequel} />
                    </div>

                    { news && news.length > 0 &&
                    <h2>Hírek</h2>
                    }
                    <div className={"news-boxes"}>
                        <BoxContainer items={news.map(this.mapBoxContainerData)}  />
                    </div>

                    <div className={"midquel"}>
                        <InnerHtml html={midquel} />
                    </div>

                    {recommendations.map(this.renderRecommendations)}

                    <div className={"sequel"}>
                        <InnerHtml html={sequel} />
                    </div>
                </div>
                { this.state.lightboxOpen && images.length > 0 &&
                <Lightbox
                    mainSrc={images[imageIndex]}
                    nextSrc={images[(imageIndex + 1) % images.length]}
                    prevSrc={images[(imageIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => {
                        this.setState({ lightboxOpen: false })
                    }}
                    onMovePrevRequest={() =>
                        this.setState({
                            imageIndex: (imageIndex + images.length - 1) % images.length,
                        })
                    }
                    onMoveNextRequest={() => {
                        this.setState({
                            imageIndex: (imageIndex + 1) % images.length,
                        })
                    }} />
                }
            </>
        )
    }
}

export default connect(store => {
    return {
        data: store.base.data,
        lightbox: store.base.lightbox
    }
})(ReadFrontpage)